export default __webpack_public_path__ + "static/6843-cc51373a5b541feb77f9f4ddaf0d0818.jpg";